import React from "react";
import { Badge } from "reactstrap";
import { Icon } from "components/Structure/IconComponent";
import { useSkin } from "@hooks/useSkin";

import { StyledAvatar } from "../wrapperArquivaMix.styles";
import { ContentList, CheckIcon } from "../OportunidadeNegociacao/list.styles";

export const QueimaDeCaixaContent = () => {
  const { skin } = useSkin();

  return (
    <>
      <div className="d-flex align-items-center gap-1">
        <StyledAvatar skin={skin}>
          <Icon name="cadeado" color="#fff" size={48} />
        </StyledAvatar>
        <div>
          <h1 className="text-dark text-left fs-3 fw-bolder">
            Contéudo Exclusivo
          </h1>
          <Badge color="light-primary" pill>
            Apenas para assinantes premium
          </Badge>
        </div>
      </div>

      <div className="mt-1">
        <div className="mb-2">
          <span className="text-dark fw-bolder">
            Seu concorrente vende mais barato — não porque compra melhor…
          </span>
          <br />
          <strong className="text-primary">mas porque tributa certo.</strong>
        </div>
        <p className="text-dark m-0">
          Quando a alíquota, o CST, o NCM ou o CEST estão incorretos, o imposto
          entra no custo de forma errada — &nbsp;
          <b>e seu preço final sobe sem necessidade.</b>
        </p>

        <p className="text-dark">
          Mesmo aplicando a mesma margem e comprando do mesmo fornecedor, você
          fica mais caro que o concorrente.
        </p>

        <div className="">
          <p className="text-dark m-0">
            A nota com informações da Mix Fiscal mostra item a item:
          </p>
          <ContentList className="list-unstyled">
            <li className="text-dark">
              <CheckIcon>✔</CheckIcon> Alíquota aplicada
            </li>
            <li className="text-dark">
              <CheckIcon>✔</CheckIcon> CST correto
            </li>
            <li className="text-dark">
              <CheckIcon>✔</CheckIcon> NCM e CEST utilizados
            </li>
            <li className="text-dark">
              <CheckIcon>✔</CheckIcon> Diferença real de imposto por produto
            </li>
            <li className="text-dark">
              <CheckIcon>✔</CheckIcon> Onde o custo está sendo inflado por erro
              fiscal
            </li>
          </ContentList>
        </div>
      </div>
    </>
  );
};
